if (!customElements.get('cx-product-info')) {
  customElements.define(
    'cx-product-info',
    class CxProductInfo extends HTMLElement {
      onVariantChangeUnsubscriber = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
      }

      handleVariantChange({ data: { sectionId, html, variant } }) {
        const metafields = this.getSelectedVariantMetafields(html);

        this.updateVariantMetafieldInputs(sectionId, metafields);
      }

      getSelectedVariantMetafields(productInfoNode) {
        const selectedVariantMetafields = productInfoNode.querySelector('variant-selects [data-selected-variant-metafields]')?.innerHTML;
        return !!selectedVariantMetafields ? JSON.parse(selectedVariantMetafields) : null;
      }

      updateVariantMetafieldInputs(sectionId, metafields) {
        document.querySelectorAll(
          `#product-form-${sectionId}, #product-form-installment, #product-form-installment-${sectionId}, #product-form-${sectionId}--alt`
        ).forEach((productForm) => {
          const documentEntry = productForm.querySelector('input[name="properties[_document_entry]"]');
          documentEntry.value = metafields.document_entry ?? '';
          documentEntry.dispatchEvent(new Event('change', { bubbles: true }));

          const lineNumber = productForm.querySelector('input[name="properties[_line_number]"]');
          lineNumber.value = metafields.line_number ?? '';
          lineNumber.dispatchEvent(new Event('change', { bubbles: true }));

          const maximumQuantity = productForm.querySelector('input[name="properties[_maximum_quantity]"]');
          maximumQuantity.value = metafields.maximum_quantity ?? '';
          maximumQuantity.dispatchEvent(new Event('change', { bubbles: true }));

          const hazardous = productForm.querySelector('input[name="properties[_hazardous]"]');
          hazardous.value = metafields.hazardous ?? '';
          hazardous.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }
  );
}
